import React, { useState } from "react";
import { Box, Typography, TextField, Alert, Grid, Button } from "@mui/material";
import { ContainedButton } from "../buttonCompo/Buttons";

const ContactForm = () => {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    number: "",
    message: "",
  });

  const [errors, setErrors] = useState({});
  const [successMessage, setSuccessMessage] = useState("");

  const validateForm = () => {
    let newErrors = {};

    if (!formData.firstName.trim()) newErrors.firstName = "First name is required";
    if (!formData.lastName.trim()) newErrors.lastName = "Last name is required";

    if (!formData.email.trim()) {
      newErrors.email = "Email is required";
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = "Enter a valid email address";
    }

    if (!formData.message.trim()) newErrors.message = "Message cannot be empty";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    setTimeout(() => {
      setSuccessMessage("Your request has been submitted successfully!");
      setFormData({
        firstName: "",
        lastName: "",
        email: "",
        number: "",
        message: "",
      });
      setErrors({});
    }, 1000);
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundImage: `url(${process.env.PUBLIC_URL}/icons/login/loginBg.svg)`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <Grid
        container
        spacing={2}
        maxWidth={600}
        sx={{
          borderRadius: "10px",
          padding: "20px",
        }}
      >
        <Grid item xs={12}>
          <Typography variant="h5" fontWeight={700} color="#1560BD" sx={{ textAlign: "center" }} gutterBottom>
            Contact Us
          </Typography>

          {successMessage && (
            <Alert severity="success" sx={{ mb: 2 }}>
              {successMessage}
            </Alert>
          )}
        </Grid>

        {/* First Name & Last Name */}
        <Grid item xs={6}>
          <TextField
            label="First Name"
            variant="outlined"
            name="firstName"
            fullWidth
            value={formData.firstName}
            onChange={handleChange}
            error={!!errors.firstName}
            helperText={errors.firstName}
          />
        </Grid>
        <Grid item xs={6}>
          <TextField
            label="Last Name"
            variant="outlined"
            name="lastName"
            fullWidth
            value={formData.lastName}
            onChange={handleChange}
            error={!!errors.lastName}
            helperText={errors.lastName}
          />
        </Grid>

        {/* Email & Phone Number */}
        <Grid item xs={6}>
          <TextField
            label="Email"
            variant="outlined"
            name="email"
            type="email"
            fullWidth
            value={formData.email}
            onChange={handleChange}
            error={!!errors.email}
            helperText={errors.email}
          />
        </Grid>
        <Grid item xs={6}>
          <TextField
            label="Phone Number"
            variant="outlined"
            name="number"
            type="tel"
            fullWidth
            value={formData.number}
            onChange={handleChange}
          />
        </Grid>

        {/* Message (Full Width) */}
        <Grid item xs={12}>
          <TextField
            label="Message"
            variant="outlined"
            name="message"
            multiline
            rows={4}
            fullWidth
            value={formData.message}
            onChange={handleChange}
            error={!!errors.message}
            helperText={errors.message}
          />
        </Grid>

        {/* Submit Button (Full Width) */}
        <Grid item xs={12}>
          <ContainedButton
            label="Submit"
            textColor="white"
            onClick={handleSubmit}
            // sx={{ padding: "10px", fontSize: "16px", fontWeight: "bold" }}
            width="100%"
            height="50px"
            fontSize="16px"
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default ContactForm;
